import { render, staticRenderFns } from "./DeductionsPlanDetailsAdd.vue?vue&type=template&id=744419fc&scoped=true&"
import script from "./DeductionsPlanDetailsAdd.vue?vue&type=script&lang=js&"
export * from "./DeductionsPlanDetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744419fc",
  null
  
)

export default component.exports